import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination, Mousewheel, FreeMode } from 'swiper/modules'

export function simpleSwiper() {

  const swiper = new Swiper('.swiper-simple', {
    modules: [Autoplay, Navigation, Pagination],
    // centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false
    },
    speed: 750,
    // Touch control parameters for better mobile performance
    touchRatio: 1,
    threshold: 10,
    shortSwipes: true,
    longSwipesRatio: 0.5,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      320: {
        slidesPerView: 1.2,
         spaceBetween: 5,
      },
      992: {
        slidesPerView: 1,
         spaceBetween: 0,
      },
    }
  })

}

export function gallerySwiper(deviceData) {

  const gallerySection = document.querySelector('.gallery-wrapper')
  const galleryHeight = gallerySection.dataset.height

  if (deviceData.isDesktop === true) {
    gallerySection.style.height = galleryHeight
  }

  let paginationEl = document.querySelector('.swiper-gallery .swiper-pagination')

  if (!paginationEl) {
    paginationEl = document.createElement('div')
    paginationEl.classList.add('swiper-pagination')
    document.querySelector('.swiper-gallery').appendChild(paginationEl)
  }

  const galleryModules = [Autoplay, Navigation, Pagination]

  const galleryConfig = {
    modules: galleryModules,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    allowTouchMove: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: paginationEl,
      clickable: true
    },
    breakpoints: {
      320: {
        speed: 800,
      },
      992: {
        speed: 1000,
      },
    }
  }

  if (deviceData.isDesktop) {
    galleryConfig.grabCursor = true
    galleryModules.push(Mousewheel)
    galleryConfig.mousewheel = {
      enabled: true,
      releaseOnEdges: true,
      sensitivity: 1.1
    }
  }

  const swiperGallery = new Swiper('.swiper-gallery', galleryConfig)

}

export function swiperDragger() {

  const swiperDragger = document.querySelectorAll('.swiper-dragger')

  swiperDragger.forEach((swiper) => {
    let paginationEl = swiper.querySelector('.swiper-pagination')

    if (!paginationEl) {
      paginationEl = document.createElement('div')
      paginationEl.classList.add('swiper-pagination')
      swiper.appendChild(paginationEl)
    }

    new Swiper(swiper, {
      modules: [Autoplay, Pagination],
      spaceBetween: 0,
      slidesPerView: 1,
      loop: true,
      speed: 750,
      allowTouchMove: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      pagination: {
        el: paginationEl,
        clickable: true
      }
    })
  })

}

export function avancesSwiper(deviceData) {

  const gallerySection = document.querySelector('.gallery-wrapper')
  const galleryHeight = gallerySection.dataset.height

  if (deviceData.isDesktop === true) {
    gallerySection.style.height = galleryHeight
  }

  // Crear instancias de Swiper para cada galería de avances
  const swiperInstances = []
  const galleryElements = document.querySelectorAll('.swiper-avances')

  galleryElements.forEach((gallery, index) => {
    const swiper = new Swiper(gallery, {
      modules: [Autoplay, Navigation, Pagination, Mousewheel, FreeMode],
      spaceBetween: 10,
      initialSlide: 0,
      speed: 1000,
      preloadImages: true,
      updateOnImagesReady: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: gallery.querySelector('.swiper-button-next'),
        prevEl: gallery.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          freeMode: false,
          mousewheel: false
        },
        768: {
          slidesPerView: 1,
          freeMode: false,
          mousewheel: false
        },
        1024: {
          slidesPerView: 1,
          freeMode: false,
          mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            sensitivity: 1.3
          }
        }
      },
      on: {
        // Cuando cambia el slide (usar slideChangeTransitionEnd para que las clases estén actualizadas)
        slideChangeTransitionEnd: function() {
          // Pausar todos los videos del swiper
          const allVideos = gallery.querySelectorAll('.gallery-video')
          allVideos.forEach(video => {
            video.pause()
          })

          // Reproducir video del slide activo si existe
          const activeSlide = gallery.querySelector('.swiper-slide-active')
          const activeVideo = activeSlide ? activeSlide.querySelector('.gallery-video') : null
          if (activeVideo) {
            activeVideo.play()
          }
        },
        // Cuando se inicializa el swiper
        init: function() {
          // Pequeño delay para asegurar que las clases están aplicadas
          setTimeout(() => {
            const firstSlide = gallery.querySelector('.swiper-slide-active')
            const firstVideo = firstSlide ? firstSlide.querySelector('.gallery-video') : null
            if (firstVideo) {
              firstVideo.play()
            }
          }, 100)
        }
      }
    })

    swiperInstances.push(swiper)
  })

  // Implementar navegación entre galerías de avances
  const navItems = document.querySelectorAll('.gallery-wrapper nav li')

  navItems.forEach((navItem, index) => {
    navItem.addEventListener('click', () => {
      // Pausar todos los videos de todas las galerías
      galleryElements.forEach(gallery => {
        const allVideos = gallery.querySelectorAll('.gallery-video')
        allVideos.forEach(video => video.pause())
      })

      // Remover clase active de todos los nav items
      navItems.forEach(item => item.classList.remove('active'))
      // Agregar clase active al item clickeado
      navItem.classList.add('active')

      // Ocultar todas las galerías
      galleryElements.forEach(gallery => gallery.style.display = 'none')

      // Mostrar la galería correspondiente
      const targetDate = navItem.dataset.target
      const targetGallery = document.querySelector(`.swiper-avances[data-date="${targetDate}"]`)
      if (targetGallery) {
        targetGallery.style.display = 'block'
        // Actualizar el swiper correspondiente
        const swiperIndex = Array.from(galleryElements).indexOf(targetGallery)
        if (swiperInstances[swiperIndex]) {
          swiperInstances[swiperIndex].update()

          // Reproducir video del slide activo en la nueva galería si existe
          setTimeout(() => {
            const activeSlide = targetGallery.querySelector('.swiper-slide-active')
            const activeVideo = activeSlide ? activeSlide.querySelector('.gallery-video') : null
            if (activeVideo) {
              activeVideo.play()
            }
          }, 100) // Pequeño delay para asegurar que el DOM se ha actualizado
        }
      }
    })
  })

}
